
export const backend_path='https://tneabooklet.tnlea.com/api'
// export const backend_path='http://localhost:5000/api';